
/* Example 
 <BaseInput
        class="mt-10"
        v-model="text"
        label="fancy label"
        id="input id"
        type="text"
        @keyup.enter="text2 = 'I did it'"
      ></BaseInput>
*/
export default {
  inheritAttrs: "false",
  name: "BaseTextArea",
  props: {
    id: { type: String, default: "" },
    rows: { type: Number, default: 3 },
    label: { type: String, default: "" },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    placeholder: { type: String, default: "" }
  },
  methods: {
    updateInput(event) {
      this.$emit("update:modelValue", event.target.value);
    }
  }
};
